export const getBrandName = () => {
  const hostname =
    typeof window !== "undefined"
      ? window.location.hostname.replace(/^www\./, "")
      : "";

  const isGapalyzeDomain = hostname === "gapalyze.com";

  const brandName = isGapalyzeDomain ? "Gapalyze" : "Throughout Technologies";//hello@gapalyze.com
  const address = isGapalyzeDomain ? "2 Ganesh Puri Colony, Khajrana, Indore Khajrana, Indore, Indore- 452016, Madhya Pradesh" : "103, Sanghi Manor, Yeshwant Niwas Rd, Maan Sarovar, Indore, Madhya Pradesh 452003";//hello@gapalyze.com
  const phone = isGapalyzeDomain ? "+91 6262-606-167" : "096303 03150";//hello@gapalyze.com
  const mail = isGapalyzeDomain ? "hello@gapalyze.com" : "hello@throughouttechnologies.com"
  const normalizedBrand = brandName.toLowerCase().replace(/\s+/g, '');
  const website = isGapalyzeDomain
  ? "https://www.gapalyze.com"
  : "https://www.marketplace.throughouttechnologies.com";

  const effectiveDate = 'October 7, 2025'

  return {
    brandName,
    normalizedBrand,
    isGapalyzeDomain,
    mail,
    website,
    effectiveDate,
    phone,
    address
  };
};
